import React from 'react';
import styles from '@UILayer/UILayer.scss';

export const ReconnectIcon: React.FC<{}> = () => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 84.1 56.1">
            <g id="Background_00000106863908464983020510000008499499222019230910_" style={{ display: 'none' }}>
                <rect x="10.7" y="12.9" style={{ display: 'inline' }} width="78.7" height="78.7" />
                <path
                    style={{ display: 'inline', fill: 'white' }}
                    d="M43.3,78.6c0.5,0,1.2,0.2,1.2,0.2c0.7,0,5-0.1,5.2,0c0.4,0.2-0.4,0.3-1.1,0.2
		c0,0.5,1.5,0.1,2.5,0.3c-1.3,0-2.4,0.1-3.6,0.3c-0.7-0.1-1.4,0-2.1-0.1c0,0-0.2-0.2-0.2-0.2c-1.1,0-2.5,0.2-2.8-0.2
		c-0.7,0.3-1.7-0.3-3-0.2c1.9,0.1,1.5-0.2,1.6-0.2c0.4,0,0.7,0.1,1.2,0.1C42.5,78.8,43.2,78.6,43.3,78.6z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M29.6,76.7c-0.2,0-0.4,0.1-0.5,0.2c-0.1-0.6-1.7,0.6-1.7,0.7c-0.1,0.4,1.6,1,0.6,1
		c0,0-0.6-0.3-0.7-0.4c-0.7,0.3-0.9,0-0.9,0.3c-2.4-1.2,0.2-2.1,1.6-1.8C28.2,76.4,29.4,76.3,29.6,76.7z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M72.7,76.1c0.1,0,2.5,0.9,2.6,1.3c0.1,0.4-0.7,0.8-0.8,0.8c-0.9,0.2,0.7-0.5,0-1.2
		c-1,1.5,0.1,0.4-1.2-0.3c-0.4-0.2-2.8-0.6-0.8-0.5C72.5,76.3,72.7,76.1,72.7,76.1z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M76.2,76.1c0.6,0.2,3.7,1.2,2,2c-1.3,0.6,0-0.4-0.1-0.7c-0.2-0.3-0.3,0.3-0.4,0.3
		c-0.1,0-0.4-0.9-2.2-1.6C75.9,76.1,76,76.5,76.2,76.1z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M68.9,76.5c3.4,0.7,1.3,2,0.9,1.8c-0.4-0.1,1.2-0.8-0.2-1.3c0.5,0.6,0,1.1-0.4,1.2
		c-0.7,0,0.9-0.6-0.8-1.4C68.5,76.5,69,76.9,68.9,76.5z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M23.5,76.2c0.6-0.1,0.3,0.6-0.8,0.6c-1.3,1.1-0.2,0.5-0.5,1.5c-1.4-0.3-1.6-0.7-0.3-1.5
		C22.1,76.8,23.4,76.2,23.5,76.2z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M71.7,76.6c0.7,0,2.9,0.9,1.3,1.5c-0.2,0.1-0.3-0.1-0.4-0.1c0,0-0.3,0.2-0.4,0.2
		c-0.5-0.1,1.5-0.8-0.5-1.5V76.6z"
                />
                <path
                    style={{ display: 'inline' }}
                    d="M29.6,76.7c0,0,0,0.1,0.1,0.2c-1.6,0.7,0,1.3-0.4,1.4c-1.2-0.3-1.3-0.9-0.2-1.5
		C29.1,76.8,29.4,76.8,29.6,76.7z"
                />
                <path style={{ display: 'inline' }} d="M70.3,76.5c0.1,0,2.3,0.8,1.1,1.6c-1.2,0.8-0.1-0.4-0.1-0.5C71.3,77,69.7,76.6,70.3,76.5z" />
                <path style={{ display: 'inline' }} d="M46.1,77c-0.5-0.1-1.8,0.3-2.1,0.1c-0.4-0.2,1.2-0.4,1.2-0.7C45.4,76.6,45.8,76.8,46.1,77z" />
                <path style={{ display: 'inline' }} d="M24,76.8c0.9-0.2-1.2,0.5,0,1.5C22.1,78,23.4,76.9,24,76.8z" />
                <path style={{ display: 'inline' }} d="M19.2,76.6c0.9,0-1.5,0.7-0.9,1.5C16.8,77.8,18.7,76.7,19.2,76.6z" />
                <path style={{ display: 'inline' }} d="M81,76.7c0.8,0.2,1.9,0.9,0.8,1.5C81.8,77.1,81.2,77.2,81,76.7z" />
                <path
                    style={{ display: 'inline' }}
                    d="M68.1,76.7c0.1,0,1.1,0.5,1,1c0,0.1-0.7,0.6-0.8,0.6c-0.6,0.1,1.2-0.5-0.3-1.4
		C68,76.8,68.1,76.7,68.1,76.7z"
                />
                <path style={{ display: 'inline' }} d="M20.1,76.7c0.8,0-1,1-0.4,1.3C18.3,78.2,19.9,76.7,20.1,76.7z" />
                <path style={{ display: 'inline' }} d="M79.6,76.7c0.4,0,1.7,0.9,1.1,1.3c-0.5,0.3-0.1-0.7-1.2-1.2L79.6,76.7z" />
                <path style={{ display: 'inline' }} d="M29.9,76.9c0.1,0,0.2,0,0.3,0c-0.9,1,0,0.9-0.3,1.3C28.5,77.7,29.7,77,29.9,76.9z" />
                <path
                    style={{ display: 'inline' }}
                    d="M30.7,77c0.8-0.1-0.1,0.2,0,0.8c0,0,0.2,0.2,0.2,0.2c0,0.4-0.9-0.1-0.8-0.6
		C30.1,77.4,30.6,77,30.7,77z"
                />
            </g>
            <g>
                <path  className={styles.reconnect_icon_main}
                    d="M69.3,17c-0.3-0.7-2.4-2.7-3-3.3C57.9,5.8,46.5,1.4,35,1.7C25.1,1.9,15.1,5.8,7.6,12.2c-0.7,0.6-4.2,3.9-4.5,4.4
		c-1.6,2.9,1.7,6.5,5.2,4.6c0.6-0.3,2.6-2.5,3.5-3.2C24.6,6.9,43.3,5.8,57.3,15.6c4.8,3.4,6.5,7.3,10,5.9C69,20.8,69.9,18.7,69.3,17
		z"
                />
                <path  className={styles.reconnect_icon_main}
                    d="M56.6,22.1c-6.2-5.2-14-7.7-22.1-7.4c-7.5,0.3-14.7,3.4-20.2,8.5c-0.7,0.6-2.8,2.7-3,3.4c-1,3,2.4,5.1,5.3,4.1
		c0.7-0.3,3.7-3.3,4.9-4.2c7.1-5.1,16.8-6,24.7-2.5c5.2,2.3,7.7,5.8,8.5,6.3c3,2,7.9-0.9,5.6-4.4C60,25.2,57.4,22.8,56.6,22.1z"
                />
                <path  className={styles.reconnect_icon_main}
                    d="M49.9,32.5c-4.3-3.5-9.9-5.1-15.4-4.8C30,28,24.3,30.3,21.1,33.5c-2.8,2.8-0.8,6.3,1.7,6.5c2.6,0.3,3.1-1.3,4.9-2.5
		c3-2.1,6.8-2.9,10.4-2.5c5.1,0.6,7.8,3.9,8.6,4.5c2.1,1.3,5.2,0.2,5.6-2.3C52.8,34.9,51.5,33.8,49.9,32.5z"
                />
                <path  className={styles.reconnect_icon_main} d="M37.6,39.7c-8.2-1.3-12.8,8.8-6.3,13.9c0.3,0.2,0.6,0.4,0.9,0.6c0.8,0.2,4.8,2.6,9-0.8C46.5,49.1,43.6,40.7,37.6,39.7z" />
            </g>
            <g>
                <path
                    style={{ fill: '#DB1F26' }}
                    d="M58.9,6.2L41.5,36.3c-1.3,2.2,0.3,4.9,2.8,4.9h34.7c2.5,0,4.1-2.7,2.8-4.9L64.5,6.2
		C63.3,4,60.1,4,58.9,6.2z"
                />
                <g>
                    <path
                        style={{ fill: '#FFFFFF' }}
                        d="M61.8,31.6c0.7,0,1.2,0.2,1.7,0.6c0.4,0.4,0.6,0.9,0.6,1.6c0,0.6-0.2,1.1-0.6,1.5
			c-0.4,0.4-1,0.6-1.7,0.6c-0.7,0-1.2-0.2-1.7-0.6c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.6,0.2-1.1,0.6-1.6C60.5,31.8,61.1,31.6,61.8,31.6z
			 M63.5,29.3h-3.4L59.6,15h4.4L63.5,29.3z"
                    />
                </g>
            </g>
        </svg>
    );
};
